import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSearchH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 11c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21-9.402-21-21-21M9 32C9 19.298 19.298 9 32 9s23 10.298 23 23-10.297 23-23 23S9 44.703 9 32",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M47.293 47.293a1 1 0 0 1 1.414 0l13 13a1 1 0 0 1-1.414 1.414l-13-13a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  }));
}
var IcSearchH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearchH72));

export { IcSearchH72 as I };
